module.exports = __webpack_public_path__ + "1782a8e9e23454d86e7281495011f832.svg";